import React from 'react'
import './Home.css'
import Product from './Product'

function Home() {
  return (
    <div className='home'>
        <div className='home__container'>
            <img
                className="home__image"
                src="https://images-eu.ssl-images-amazon.com/images/G/02/digital/video/merch2016/Hero/Covid19/Generic/GWBleedingHero_ENG_COVIDUPDATE__XSite_1500x600_PV_en-GB._CB428684220_.jpg"
                alt=""
            />
            <div className="home__row">
          <Product
            id="12321341"
            title="Plus Size Kaftan Dress Tunic Long Maxi Kimono Caftan Gown"
            price={14}
            rating={5}
            image="https://m.media-amazon.com/images/I/81vsp9xGSiS._AC_UY741_.jpg"
          />
           <Product
            id="123"
            title="Soda Single Lug Sole Chunky Heel Combat Ankle Boot"
            price={50}
            rating={5}
            image="https://m.media-amazon.com/images/I/819ldm53F-L._AC_UX695_.jpg"
          />
          <Product
            id="49538094"
            title="KSUNEE Graph Paper Notebook - 4 Pack B5 Graphing Notebook"
            price={17.84}
            rating={4}
            image="https://m.media-amazon.com/images/I/71Xk2tudWSL._AC_SL1500_.jpg"
          />
        </div>

        <div className="home__row">
          <Product
            id="4903850"
            title="Samsung LC49RG90SSUXEN 49' Curved LED Gaming Monitor"
            price={199.99}
            rating={3}
            image="https://images-na.ssl-images-amazon.com/images/I/71Swqqe7XAL._AC_SX466_.jpg"
          />
          <Product
            id="23445930"
            title="Amazon Echo (3rd generation) | Smart speaker with Alexa, Charcoal Fabric"
            price={98.99}
            rating={5}
            image="https://media.very.co.uk/i/very/P6LTG_SQ1_0000000071_CHARCOAL_SLf?$300x400_retinamobilex2$"
          />
          <Product
            id="3254354345"
            title="New Apple iPad Pro (12.9-inch, Wi-Fi, 128GB) - Silver (4th Generation)"
            price={598.99}
            rating={4}
            image="https://images-na.ssl-images-amazon.com/images/I/816ctt5WV5L._AC_SX385_.jpg"
          />
        </div>

        <div className="home__row">
          <Product
            id="90829332"
            title="Samsung Curved LED Gaming Monitor - Super Ultra Wide Dual WQHD 5120 x 1440"
            price={1094.98}
            rating={4}
            image="https://images-na.ssl-images-amazon.com/images/I/6125mFrzr6L._AC_SX355_.jpg"
          />
          <Product
            id="9082933"
            title="Sweetcrispy Coffee Table, Lift Top Coffee Table x 1440"
            price={69.70}
            rating={4}
            image="https://m.media-amazon.com/images/I/71ExrfUVAnL._AC_SL1500_.jpg"
          />
          <Product
            id="8082933"
            title="Ethiopian Coffee Beans Medium Roast"
            price={17.00}
            rating={5}
            image="https://m.media-amazon.com/images/I/71-3gW1p35L._SL1500_.jpg"
          />
        </div>
        </div>

    </div>
  )
}

export default Home